import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface HasOrdersState {
  isLoading: boolean;
  loaded: boolean;
}

export const getInitialState = (): HasOrdersState => ({
  isLoading: false,
  loaded: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.GET_HAS_ORDERS}_REQUEST`]: (state: HasOrdersState) => ({
    ...getInitialState(),
    isLoading: true
  }),
  [`${ApiConstants.GET_HAS_ORDERS}_SUCCESS`]: (state: HasOrdersState) => ({
    loaded: true,
    isLoading: false
  }),
  [`${ApiConstants.GET_HAS_ORDERS}_FAILURE`]: (state: HasOrdersState) => ({
    ...getInitialState()
  })
});
